// extracted by mini-css-extract-plugin
export default {"overlay":"style_overlay__0Ci4-","alert-dialog":"style_alert-dialog__12hBr","content":"style_content__IMgfN"};